import * as React from 'react';
import { ReactElement } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import NavBarTitleViewStyles from './NavBarTitleViewStyles';
import { observer } from 'mobx-react';
import { useViewModel } from '../../../hooks/useViewModel';
import { NavBarTitleViewModel } from './NavBarTitleViewModel';

/**
 * NavBarTitleView component that displays the application logo and optional course name.
 * Clicking the logo navigates the user back to the home page and clears the current course.
 *
 * @returns {ReactElement} The rendered navbar title with logo
 * @author Julien Tietke <j.tietke@tj-labs.de>
 */
const NavBarTitleView = observer((): ReactElement => {
	const { classes } = NavBarTitleViewStyles();
	const viewModel: NavBarTitleViewModel = useViewModel(NavBarTitleViewModel);

	/**
	 * Handles click on the logo - clears course name and navigates home.
	 * @author Julien Tietke <j.tietke@tj-labs.de>
	 */
	const handleLogoClick = (): void => {
		viewModel.clearCourseName();
		viewModel.navigateHome();
	};

	return (
		<Box className={classes.container}>
			<img src='/img/logo_rgb.png' alt='Smart in die Natur' className={classes.logo} onClick={handleLogoClick} />
			{viewModel.getCourseName() && (
				<Typography variant={'h1'} className={classes.courseName} noWrap>
					{viewModel.getCourseName()}
				</Typography>
			)}
		</Box>
	);
});

export default NavBarTitleView;
